import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { io } from 'socket.io-client';
import { TOKEN } from '../statics/localStorage';
import { APP_ID, SOCKET_BASE_URL } from '../api/static.data.pnp';
import { socketKeys } from '../statics/socketKeys';


const ChatContext = createContext();

export const useSocket = () => {
    const state = useContext(ChatContext);
    if (!state) throw new Error('State Is Undefined');
    return state;
}

const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(undefined);

    const joinAdminInRoom = useCallback((chatSessionId) => {
        if (socket) {
            socket.emit(socketKeys.JOIN_ADMIN, { 'chatSessionId': chatSessionId });
        } else {
            console.log("Socket is not connected")
        }
    }, [socket]);


    useEffect(() => {
        const _socket = io(SOCKET_BASE_URL, {
            transports: ['websocket'],
            autoConnect: true,
            auth: {
                "app-id": APP_ID,
                "token": TOKEN(),
                "user-type": "admin"
            }
        });

        _socket.on('test:pong', () => {
            console.log('p');

        });

        _socket.on("connect", (res) => {
            // setInterval(() => {
            _socket.emit('test:ping', {});
            // }, 1000);

            _socket.emit(socketKeys.ORG_JOIN, {});
            return;
        });

        setSocket(_socket);
        return () => {
            _socket.disconnect();
            setSocket(undefined)
        };
    }, []);



    return (
        <ChatContext.Provider value={{ joinAdminInRoom, socket }}>{children}</ChatContext.Provider>
    )
}

export default SocketProvider